// Program start date: November 24, 2025 (Monday of this week)
export const PROGRAM_START_DATE = '2025-11-24';

let programDays = [];

/**
 * Load and normalize the program data from JSON
 */
export async function loadProgram() {
  const res = await fetch('/data/SFRE_10_Week_Program.json');
  const data = await res.json();
  // Handle both new format (with wrapper) and old format (array directly)
  const weeks = data.weeks || data;
  programDays = normalizeProgram(weeks);
  return programDays;
}

/**
 * Flatten weeks/days structure into a single array of program days
 * Each day gets an index and a concrete calendar date
 */
function normalizeProgram(weeks) {
  const days = [];
  // Parse as local date to avoid timezone issues
  const [startYear, startMonth, startDay] = PROGRAM_START_DATE.split('-').map(Number);
  const startDate = new Date(startYear, startMonth - 1, startDay);
  let dayIndex = 0;

  for (const week of weeks) {
    for (const dayData of week.days) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + dayIndex);

      days.push({
        index: dayIndex,
        // Support both camelCase (new) and snake_case (old) field names
        weekNumber: week.weekNumber || week.week_number,
        dayName: dayData.dayOfWeek || dayData.day_name,
        date: formatDate(date),
        workoutTitle: dayData.workoutTitle || dayData.workout_title,
        description: dayData.description
      });

      dayIndex++;
    }
  }

  return days;
}

/**
 * Format a Date object as YYYY-MM-DD
 */
export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Parse a YYYY-MM-DD string into a Date object (local time)
 */
export function parseDate(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/**
 * Get the program day for a given date, with clamping to bounds
 */
export function getProgramDayForDate(date) {
  const startDate = parseDate(PROGRAM_START_DATE);
  const diffMs = date.getTime() - startDate.getTime();
  const dayIndex = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // Clamp to valid range
  if (dayIndex < 0) {
    return programDays[0];
  }
  if (dayIndex >= programDays.length) {
    return programDays[programDays.length - 1];
  }

  return programDays[dayIndex];
}

/**
 * Get the program day by index
 */
export function getProgramByIndex(index) {
  if (index < 0) return programDays[0];
  if (index >= programDays.length) return programDays[programDays.length - 1];
  return programDays[index];
}

/**
 * Get total number of program days
 */
export function getProgramLength() {
  return programDays.length;
}

/**
 * Get a Date object for a program day index
 */
export function getDateForProgramIndex(index) {
  const day = getProgramByIndex(index);
  return parseDate(day.date);
}
